import React from 'react';
import { CheckCircle, Clock, AlertCircle, Loader } from 'lucide-react';

/**
 * Reusable job status badge component
 * Displays status with icon and color coding
 */
export const JobStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'completed':
        return {
          icon: CheckCircle,
          label: 'Complete',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          iconColor: 'text-green-600'
        };
      case 'processing':
        return {
          icon: Loader,
          label: 'In Progress',
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          iconColor: 'text-blue-600',
          animate: true
        };
      case 'queued':
        return {
          icon: Clock,
          label: 'Queued',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          iconColor: 'text-yellow-600'
        };
      case 'failed':
        return {
          icon: AlertCircle,
          label: 'Failed',
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          iconColor: 'text-red-600'
        };
      default:
        return {
          icon: Clock,
          label: status || 'Unknown',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          iconColor: 'text-gray-600'
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}>
      <Icon
        className={`w-3.5 h-3.5 ${config.iconColor} ${config.animate ? 'animate-spin' : ''}`}
      />
      <span>{config.label}</span>
    </div>
  );
};
